import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { Supplier } from "../models/supplier";
import { AuthService } from "../../../../@core/auth/auth.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class SuppliersService {
  protected basePath = "/";

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  //To get all active suppliers
  public getSupplierList(): Observable<Supplier[]> {
    return this.httpClient.get<Supplier[]>(
      `${this.basePath}/api/supplier/getAll`).pipe(
        map((suppliers) =>
          (suppliers || []).slice().sort((a, b) =>
            (a.supplierName || '').localeCompare(b.supplierName || '', undefined, { sensitivity: 'base' })
          )
        )
      );
  }

  //Delete supplier based on Id
  public deleteSupplier(supplierId: number, saveERPFlag?: boolean): Observable<Supplier> {
    return this.httpClient.delete<Supplier>(
      `${this.basePath}/api/supplier/${supplierId}?saveERPFlag=${saveERPFlag}`);
  }

  //Create supplier with erp flag
  public createSupplier(supplier: Supplier, saveERPFlag?: boolean): Observable<Supplier> {
    let queryParameters = new HttpParams();
    if (saveERPFlag) { queryParameters = queryParameters.set('saveERPFlag', saveERPFlag.toString()); }

    return this.httpClient.post<Supplier>(
      `${this.basePath}/api/supplier`,
      supplier,
      {
        params: queryParameters
      }
    );
  }

  //Update supplier with erp flag
  public updateSupplier(supplier: Supplier, saveERPFlag?: boolean): Observable<Supplier> {
    let queryParameters = new HttpParams();
    if (saveERPFlag) { queryParameters = queryParameters.set('saveERPFlag', saveERPFlag.toString()); }

    return this.httpClient.put<Supplier>(
      `${this.basePath}/api/supplier/${supplier.id}`,
      supplier,
      {
        params: queryParameters
      }
    );
  }
}
